import React, {Component} from 'react'
import '../styles/index.scss'
import BasketsMergeSetPage from './BasketsMergeSetPage'


class BasketsMergeSetPageContainer extends Component {
    render() {
        return (
            <div className='BasketsPageContainer'>
                <BasketsMergeSetPage/>
            </div>
        )
    }
}

export default BasketsMergeSetPageContainer
